import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import InfoContainer from './InfoContainer';
import classes from './CookieContainer.module.css';
import { SettingsContextAnalyticsStatus, useSettingsContext } from '../../contexts/SettingsContext';

type CookieContainerProps = {
  backgroundColor: string;
  typography: StreamingPlayerTypography;
};

function CookieContainer({ backgroundColor, typography }: CookieContainerProps) {
  const { setAnalytics } = useSettingsContext();

  return (
    <InfoContainer backgroundColor={backgroundColor} typography={typography}>
      <h2>
        Would you like to help us?
      </h2>
      <p>
        We use cookies to
        {' '}
        <strong>improve the handling and behaviour of our player</strong>
        . Do you allow us the usage?
      </p>
      <div className={classes.cookieContainerButtons}>
        <button type="button" className={classes.cookieContainerButton} onClick={() => setAnalytics(SettingsContextAnalyticsStatus.ENABLED)}>
          Yes, accept the usage
        </button>
        <button type="button" className={classes.cookieContainerButton} onClick={() => setAnalytics(SettingsContextAnalyticsStatus.DISABLED)}>
          Don't accept
        </button>
      </div>
      <small>
        <a href="https://www.heardis.com/en/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        {' '}
        /
        {' '}
        <a href="https://www.heardis.com/en/legal-notes" target="_blank" rel="noopener noreferrer">Legal Notes</a>
      </small>
    </InfoContainer>
  );
}

export default CookieContainer;
